(() => {
  "use strict";

  const init = () => {
    const root = document.querySelector(".cs-page");
    if (!root) return;

    initQuickHelpLinks(root);
    initFaqSidebar(root);
    initPopularLinks(root);
    initFaqAccordion(root);
  };

  const jumpTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const setActiveCategory = (root, category) => {
    root.querySelectorAll(".cs-faq-panel").forEach((panel) => {
      panel.classList.toggle("is-active", panel.dataset.category === category);
    });
    root.querySelectorAll(".cs-faq-nav-btn[data-category]").forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.category === category);
    });
  };

  const initQuickHelpLinks = (root) => {
    root.querySelectorAll("[data-goto-category]").forEach((card) => {
      card.addEventListener("click", (e) => {
        e.preventDefault();
        setActiveCategory(root, card.dataset.gotoCategory);
        jumpTo(card.dataset.gotoTarget || "cs-faqs");
      });
    });
  };

  const initFaqSidebar = (root) => {
    root.querySelectorAll(".cs-faq-nav-btn[data-category]").forEach((btn) => {
      btn.addEventListener("click", () =>
        setActiveCategory(root, btn.dataset.category),
      );
    });
  };

  const initPopularLinks = (root) => {
    root.querySelectorAll("[data-popular-link]").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const { category, targetId } = link.dataset;
        setActiveCategory(root, category);
        const item = document.getElementById(targetId);
        if (item) item.classList.add("is-open");
        requestAnimationFrame(() =>
          requestAnimationFrame(() => jumpTo(targetId)),
        );
      });
    });
  };

  const initFaqAccordion = (root) => {
    root.querySelectorAll(".cs-faq-item").forEach((item) => {
      const question = item.querySelector(".cs-faq-question");
      if (question)
        question.addEventListener("click", () =>
          item.classList.toggle("is-open"),
        );
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
